import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ReportsService } from 'src/app/services/reports.service';
import saveAs from 'file-saver';
import { first } from 'rxjs';
import { ChallanMonthWiseModel } from 'src/app/models/department-reports.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import {shareReplay} from 'rxjs/operators';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-challan-month-wise-report',
  templateUrl: './challan-month-wise-report.component.html',
  styleUrls: ['./challan-month-wise-report.component.scss']
})
export class ChallanMonthWiseReportComponent implements OnInit {

  monthWise: any[];
  challanGenerated:number;
  challanAmount:number;
  challanDeposited:number;
  amountDeposited:number;
  grandChallanGenerated:number;
  grandChallanAmount:number;
  grandChallanDeposited:number;
  grandAmountDeposited:number;
  arrayIndex:number;
  tempMonthWise: any[];
  appVerificationItems: MenuItem[];
  appVerificationModel: ChallanMonthWiseModel[];
  filteredDataForExport: any = [];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  public filteredData: any = [];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  
  public userID: any;
  value:any;
  drilldownDetails:any;
  challanName:any;
  displayMaximizable:boolean;
  public subscriptions: any = [];
  public loading: boolean = false;
  routePath:any;
  subjectSub:any;
  selectedYear:any;
  constructor(private reportsService:ReportsService
     ,private messageService:MessageService
     ,private dashboard: DashboardService
     ,private router: Router
     ,private activityRecordService: ActivityRecordService
     ,private loader: AppLoaderService
     ,private service: BaseService
     ,private cryptoJsService: CryptoJsService) { }

  ngOnInit(): void {
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    
    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
          let router=this.router.url
    // this.routePath=router.split('/')
    this.subscriptions.forEach(sub => sub.unsubscribe());
        this.selectedYear=res
        
        this.loadData(this.selectedYear)
      }
          
  );
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.appVerificationModel, "District_wise_report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.appVerificationModel, "District_wise_report");
        }
      },
    ];
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe()
    }
  }
  loadData(selectedYear:any){
    // this.loader.start();
    this.loading = true;
    let sub=this.reportsService.getChallan_MonthWise_Report(selectedYear)
        .pipe(first())
        .subscribe({
          next: (data) => {
            // this.loader.close();
            this.loading = false;
            data.forEach(e=>{
              if(e.Months.length>0){
                e.Months_sort=e.Months.substr(0,e.Months.length-2)+"20"+e.Months.substr(-2);
              e.Months_sort=new Date (e.Months_sort)
              }
              
             })
            this.activityRecordService.activityRecord(this.userID, 'Challan Report (Month Wise)', '', new Date(), 'Success');

            // console.log("dataaa", data)
            if (data?.length > 0) {
              this.monthWise = data;
              this.appVerificationModel = data;
              this.tempMonthWise=data;
              this.arrayIndex=0;
              this.calculateGrandTotal()
             
            }
            else{
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
              this.monthWise =[] ;
              this.appVerificationModel =[] ;
              this.tempMonthWise=[];
              this.arrayIndex=0;
              this.calculateGrandTotal()
            }
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(this.userID, 'Challan Report (Month Wise)', '', new Date(), err);

            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          }
        });
        this.subscriptions.push(sub);
  }
  exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        return {
          "Months" : d.Months,
          "Challan Generated": d.ChallanGenerated,
          "Challan Amount": d.ChallanAmount,
          "Challan Deposited": d.ChallanDeposited,
          "Amount Deposited":d.AmountDeposited,

        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      ); 
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'Months', header: 'Months'},
      { field: 'ChallanGenerated', header: 'Challan Generated' },
      { field: 'ChallanAmount', header: 'Challan Amount' },
      { field: 'ChallanDeposited', header: 'Challan Deposited' },
      { field: 'AmountDeposited', header: 'Amount Deposited' },

    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }
  tableDataFunction(event: any) {
    this.tempMonthWise=event.filteredValue
    //console.log(event);
    this.arrayIndex=0;
    // console.log(this.vendorWise);
    this.calculateTotalApp() ;
  }
  onPage(event:any) {
        this.arrayIndex=event.first;
        this.calculateTotalApp()
        //console.log(event);
      }
calculateTotalApp() {
        this.challanGenerated=0;
        this.challanAmount=0;
        this.challanDeposited=0;
        this.amountDeposited=0;
        for(let i=this.arrayIndex ;this.tempMonthWise.length>10?i<this.arrayIndex+10:i<this.tempMonthWise.length;i++) {
         // console.log( this.totalApp,"totalAPPPPPPPPP")
          this.challanGenerated +=this.tempMonthWise[i].ChallanGenerated;
          this.challanAmount +=this.tempMonthWise[i].ChallanAmount;
          this.challanDeposited +=this.tempMonthWise[i].ChallanDeposited;
          this.amountDeposited += this.tempMonthWise[i].AmountDeposited;

        }      
    }
    calculateGrandTotal(){
      this.grandChallanGenerated=0;
      this.grandChallanAmount=0;
      this.grandChallanDeposited=0;
      this.grandAmountDeposited=0;
      for(let monthData of this.tempMonthWise) {
        this.grandChallanGenerated += monthData.ChallanGenerated;
        this.grandChallanAmount += monthData.ChallanAmount;
        this.grandChallanDeposited += monthData.ChallanDeposited;
        this.grandAmountDeposited += monthData.AmountDeposited;
    }
    }
    showMaximizableDialog_challan(actionType:any,value:any) {
   
      if(actionType=='Challan'){
        this.challanName='Challan Generated'
      }
      if(actionType=='ChallanDeposited'){
        this.challanName='Challan Deposited'
      }
      
      this.value=value;
      this.drilldownDetails={
        actionType:actionType,
        
        filterType:"Months",
        value:this.value,
        status:'Approved',
        MIType:""
      }
      
      this.displayMaximizable = true;
      // console.log(this.value,"value")
      // console.log(this.drilldownDetails,"this.drilldownDetails")
  
  }

}
